
import {
  defineComponent,
  onBeforeMount,
  reactive,
  ref,
  watch,
  computed,
} from 'vue';
import { Card, Modal } from 'ant-design-vue';
import TituloPadrao from '@/core/components/Tela/TituloPadrao.vue';
import PreviewPdf from '@/core/components/Modal/PreviewPdf.vue';
import SelecionarFiltroPeriodoMovimentoComercial from '@/components/Compartilhados/SelecionarFiltroPeriodoMovimentoComercial.vue';
import SelecionarDataInicialFinal from '@/core/components/Tela/SelecionarDataInicialFinal.vue';
import SelecionarProduto from '@/components/Cadastros/Produtos/SelecionarProduto.vue';
import Icone from '@/core/components/Icone.vue';
import { IDTODadosEmpresa } from '@/models/DTO/MeuSistema/Empresas/IDTODadosEmpresa';
import { IArquivoPdf } from '@/core/models/IArquivoPdf';
import { ECustomRenderRow, IColumn } from '@/core/models/AntDesign/IColumn';
import { EFiltroPeriodoMovimentoComercial } from '@/models/Enumeradores/Compartilhados/EFiltroPeriodoMovimentoComercial';
import { ETipoArquivo } from '@/core/models/Enumeradores/ETipoArquivo';
import { EStatusRetornoRequisicao, IRetornoRequisicao } from '@/core/models/IRetornoRequisicao';
import { useTelaBase } from '@/core/composables/TelaBase';
import { useGradeBase } from '@/core/composables/GradeBase';
import ServicoSistema from '@/servicos/MeuSistema/ServicoSistema';
import UtilitarioData from '@/core/utilitarios/UtilitarioData';
import UtilitarioMascara from '@/core/utilitarios/UtilitarioMascara';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import storeSistema from '@/store/storeSistema';
import { IDadosRelatorio, IDadosRelatorioCampo, IDadosRelatorioFiltros } from '@/models/Entidades/Relatorios/DadosRelatorio';
import SelecionarRelatorioPainelVendas from '@/components/Relatorios/Vendas/PainelVendas/SelecionarRelatorioPainelVendas.vue';
import ServicoDadosRelatorio from '@/servicos/Relatorios/ServicoDadosRelatorio';
import SelecionarCamposRelatorioPCP from '@/components/Relatorios/PCP/SelecionarCamposRelatorioPCP.vue';
import SelecionarTipoProducao from '@/components/Cadastros/PCP/SelecionarTipoProducao.vue';
import SelecionarEngenhariaProducao from '@/components/Cadastros/PCP/SelecionarEngenhariaProducao.vue';
import { IDTORelatorioPCP } from '@/models/Relatorios/PCP/IDTORelatorioPCP';
import { IParametrosRelatorioPCP } from '@/models/ParametrosRequisicao/PCP/IParametrosRelatorioPCP';
import ServicoRelatorioPCP from '@/servicos/Relatorios/ServicoRelatorioPCP';
import Totalizador from '@/core/components/Tela/Totalizador.vue';
import CriacaoEdicaoLayoutPcpModal from '@/components/Relatorios/PCP/CriacaoEdicaoLayoutPCPModal.vue';
import SelecionarTipoFiltroRelatorioPCP from '@/components/Relatorios/PCP/SelecionarTipoFiltroRelatorioPCP.vue';

export default defineComponent({
  name: 'PainelRelatorioPCPIndex',

  components: {
    TituloPadrao,
    Card,
    Icone,
    PreviewPdf,
    SelecionarFiltroPeriodoMovimentoComercial,
    SelecionarDataInicialFinal,
    SelecionarProduto,
    SelecionarCamposRelatorioPCP,
    SelecionarRelatorioPainelVendas,
    SelecionarTipoProducao,
    Totalizador,
    CriacaoEdicaoLayoutPcpModal,
    SelecionarTipoFiltroRelatorioPCP,
    SelecionarEngenhariaProducao,
  },

  setup(props) {
    const dadosEmpresa = ref<IDTODadosEmpresa>({} as IDTODadosEmpresa);

    const {
      telaBase,
      preencherEmpresasDisponiveis,
      filtrarPermissaoDadosUsuarioMultiEmpresas,
      apresentarMensagemAlerta,
      apresentarMensagemErro,
      apresentarMensagemSucesso,
    } = useTelaBase();

    const { gradeBase, defineAlturaScrollDinamica } = useGradeBase();
    const servicoRelatorioPCP = new ServicoRelatorioPCP();
    const permissaoServico = ref<boolean>(false);
    const servicoDadosRelatorio = new ServicoDadosRelatorio();
    const selectRelatorioRef = ref<any>(null);

    const state = reactive({
      identificadorRecurso: 'PAINEL_RELATORIO_PCP',
      tituloRecurso: 'Painel de Relatório de Produção',
      carregandoTela: true,
      periodo: 1,
      dados: {} as IDTORelatorioPCP,
      dataInicialSelecionada: '',
      dataFinalSelecionada: '',
      filtroPeriodo: 0,
      dataAtual: '',
      empresaSelecionada: 0,
      colunas: [] as IColumn[],
      telaMobile: false,
      qtdSelecionados: 0,
      arquivoPdf: [] as IArquivoPdf[],
      tipoRelatorio: 1,
      tipoAgrupador: 1,
      tiposFiltro: [] as number[],
      tiposProducao: [] as number[],
      engenhariaProdutos: [] as number[],
      materiasPrimas: [] as number[],
      camposRelatorio: '',
      parametros: {} as IParametrosRelatorioPCP,
      descricao: '',
      mostrarConfiguracao: 1,
      dadosRelatorio: {} as IDadosRelatorio,
      dadosCadastro: {} as IDadosRelatorio,
      dadosRelatorioCampos: '',
      codigoRelatorio: 0,
      nomeRelatorio: '',
      modalConfiguracaoVisivel: false,
      modoEdicaoModal: false,
      tipoProducaoModal: [] as number[],
      engenhariaProdutosModal: [] as number[],
      materiasPrimasModal: [] as number[],
    });

    const mostrarTotalizadorQtdProduzir = computed(() => {
      if (!state.camposRelatorio) {
        return true;
      }
      const camposMateriaPrima = ['MateriaPrima', 'QuantidadeMateriaPrima', 'EstoqueMateriaPrima'];
      const camposSelecionados = state.camposRelatorio.split(',').map((c) => c.trim());

      return !camposSelecionados.some((campo) => camposMateriaPrima.includes(campo));
    });

    function abrirModalConfiguracao() {
      state.modoEdicaoModal = false;
      state.dadosCadastro = {} as IDadosRelatorio;
      state.dadosRelatorioCampos = '';
      state.dadosCadastro.tiposFiltro = [];
      state.dadosCadastro.filtros = [];
      state.tipoProducaoModal = [];
      state.engenhariaProdutosModal = [];
      state.materiasPrimasModal = [];
      state.modalConfiguracaoVisivel = true;
    }

    function permitirMovimentacao(evt: any) {
      const item = evt.draggedContext.element;
      return item.key !== 'id';
    }

    function atualizarPosicoes() {
      state.colunas.forEach((col, i) => {
        // eslint-disable-next-line no-param-reassign
        col.position = i;
      });
    }

    const mapaCampos: Record<string, string> = {
      TipoProducao: 'tipoProducao',
      CodigoEngenharia: 'codigoEngenharia',
      EngenhariaProducao: 'engenhariaProducao',
      DataCriacao: 'dataCriacao',
      DataInicio: 'dataInicio',
      DataConclusao: 'dataConclusao',
      DataValidade: 'dataValidade',
      NumeroInterno: 'numeroInterno',
      NumeroLote: 'numeroLote',
      Status: 'descricaoStatus',
      CustoTotal: 'custoTotal',
      QuantidadeProduzir: 'quantidadeProduzir',
      MateriaPrima: 'materiaPrima',
      QuantidadeMateriaPrima: 'quantidadeMateriaPrima',
      EstoqueMateriaPrima: 'estoqueMateriaPrima',
      ProdutoAcabado: 'produtoAcabado',
      QuantidadeProdutoAcabado: 'quantidadeProdutoAcabado',
      EstoqueProdutoAcabado: 'estoqueProdutoAcabado',
      Unidade: 'unidade',
      Participacao: 'participacao',
      Observacao: 'observacao',
    };

    const mapaTitulo: Record<string, string> = {
      TipoProducao: 'Tipo de Produção',
      CodigoEngenharia: 'Cód. Engenharia',
      EngenhariaProducao: 'Engenharia',
      DataCriacao: 'Data de Criação',
      DataInicio: 'Data de Início',
      DataConclusao: 'Data de Conclusão',
      DataValidade: 'Data de Validade',
      NumeroInterno: 'Nº Interno',
      NumeroLote: 'Lote',
      Status: 'Status',
      CustoTotal: 'Custo Total',
      QuantidadeProduzir: 'Qtde a Produzir',
      MateriaPrima: 'Matéria-Prima',
      QuantidadeMateriaPrima: 'Qtde Matéria-Prima',
      EstoqueMateriaPrima: 'Estoque Matéria-Prima',
      ProdutoAcabado: 'Produto Acabado',
      QuantidadeProdutoAcabado: 'Qtde Produto Acabado',
      EstoqueProdutoAcabado: 'Estoque Produto Acabado',
      Unidade: 'Unidade',
      Participacao: '% Part.',
      Observacao: 'Observação',
    };

    function obterCustomizacao(campo: string): number | undefined {
      switch (campo) {
        case 'DataCriacao':
        case 'DataInicio':
        case 'DataConclusao':
        case 'DataValidade':
          return ECustomRenderRow.MascararData;

        case 'QuantidadeProdutoAcabado':
        case 'QuantidadeMateriaPrima':
        case 'QuantidadeProduzir':
        case 'CustoTotal':
          return ECustomRenderRow.MascararFracionado;

        case 'Participacao':
          return ECustomRenderRow.MascararPorcentagem;

        default:
          return ECustomRenderRow.HTMLPersonalizado;
      }
    }

    function montarColunas(campos: string) {
      const colunaId: IColumn = {
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
        position: 0,
        visible: false,
        ellipsis: false,
        ordering: false,
        width: 0,
        align: 'left',
      };

      if (!campos) {
        state.colunas = [colunaId];
        return;
      }

      const listaCampos = campos
        .split(',')
        .map((c) => c.trim())
        .filter((c) => c.length > 0);

      const colunasDinamicas = listaCampos.map((campo, i) => {
        const dataIndex = mapaCampos[campo];
        const customRender = obterCustomizacao(campo);

        return {
          title: mapaTitulo[campo],
          dataIndex,
          key: campo,
          position: i + 1,
          visible: true,
          ellipsis: true,
          ordering: true,
          align: 'left',
          customRenderRow: customRender,
          width: 160,
          minWidth: 80,
          maxWidth: 400,

          sorter: (a: any, b: any) => {
            const valA = a[dataIndex];
            const valB = b[dataIndex];

            if (
              customRender === ECustomRenderRow.MascararFracionado
          || customRender === ECustomRenderRow.MascararPorcentagem
            ) {
              return (valA || 0) - (valB || 0);
            }

            if (customRender === ECustomRenderRow.MascararData) {
              return new Date(valA).getTime() - new Date(valB).getTime();
            }

            return (valA || '').toString().localeCompare((valB || '').toString());
          },
        };
      });

      state.colunas = [colunaId, ...colunasDinamicas];
    }

    function iniciarResizeColuna(event: MouseEvent, coluna: IColumn) {
      event.preventDefault();

      const startX = event.clientX;
      const startWidth = coluna.width || 160;

      const onMouseMove = (e: MouseEvent) => {
        const novaLargura = startWidth + (e.clientX - startX);

        const min = coluna.minWidth ?? 80;
        const max = coluna.maxWidth ?? 600;

        // eslint-disable-next-line no-param-reassign
        coluna.width = Math.min(Math.max(novaLargura, min), max);
      };

      const onMouseUp = () => {
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
      };

      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
    }

    function prencheDatasPeriodo() {
      // eslint-disable-next-line default-case
      switch (state.periodo) {
        case EFiltroPeriodoMovimentoComercial.Hoje:
          state.dataInicialSelecionada = state.dataAtual;
          state.dataFinalSelecionada = state.dataAtual;
          break;

        case EFiltroPeriodoMovimentoComercial.Ontem:
          state.dataInicialSelecionada = UtilitarioData.diminuirDiaNaData(state.dataAtual, 1);
          state.dataFinalSelecionada = UtilitarioData.diminuirDiaNaData(state.dataAtual, 1);
          break;

        case EFiltroPeriodoMovimentoComercial.SemanaAtual:
          state.dataInicialSelecionada = UtilitarioData.diminuirDiaNaData(state.dataAtual, 7);
          state.dataFinalSelecionada = state.dataAtual;
          break;

        case EFiltroPeriodoMovimentoComercial.MesAtual:
          state.dataInicialSelecionada = UtilitarioData.obterPrimeiroDiaMes(state.dataAtual);
          state.dataFinalSelecionada = UtilitarioData.obterUltimoDiaMes(state.dataAtual);
          break;

        case EFiltroPeriodoMovimentoComercial.AnoAtual:
          state.dataInicialSelecionada = UtilitarioData.obterPrimeiroDiaAno(state.dataAtual);
          state.dataFinalSelecionada = UtilitarioData.obterUltimoDiaAno(state.dataAtual);
          break;

        case EFiltroPeriodoMovimentoComercial.Ultimos15Dias:
          state.dataInicialSelecionada = UtilitarioData.diminuirDiaNaData(state.dataAtual, 15);
          state.dataFinalSelecionada = state.dataAtual;
          break;

        case EFiltroPeriodoMovimentoComercial.Ultimos30Dias:
          state.dataInicialSelecionada = UtilitarioData.diminuirDiaNaData(state.dataAtual, 30);
          state.dataFinalSelecionada = state.dataAtual;
          break;

        case EFiltroPeriodoMovimentoComercial.Ultimos60Dias:
          state.dataInicialSelecionada = UtilitarioData.diminuirDiaNaData(state.dataAtual, 60);
          state.dataFinalSelecionada = state.dataAtual;
          break;

        case EFiltroPeriodoMovimentoComercial.Ultimos90dias:
          state.dataInicialSelecionada = UtilitarioData.diminuirDiaNaData(state.dataAtual, 90);
          state.dataFinalSelecionada = state.dataAtual;
          break;
      }
    }

    async function buscarRelatorio() {
      if (state.camposRelatorio.trim() === '') {
        return;
      }
      prencheDatasPeriodo();

      const parametrosConsulta = {} as IParametrosRelatorioPCP;
      // state.dados.itens.dados = [];

      parametrosConsulta.empresa = state.empresaSelecionada;
      parametrosConsulta.ordenacao = [];
      parametrosConsulta.periodo = state.periodo;
      parametrosConsulta.dataInicial = state.dataInicialSelecionada;
      parametrosConsulta.dataFinal = state.dataFinalSelecionada;
      parametrosConsulta.ordenacao.push('Status', 'DataCriacao|DESC');
      parametrosConsulta.tipoProducao = state.tiposProducao.map(Number);
      parametrosConsulta.engenhariaProdutos = state.engenhariaProdutos.map(Number);
      parametrosConsulta.produtos = state.materiasPrimas.map(Number);

      parametrosConsulta.tipoRelatorio = state.tipoRelatorio;
      parametrosConsulta.tipoAgrupador = state.tipoAgrupador;

      parametrosConsulta.qtdeRegistrosPagina = 1000;

      parametrosConsulta.camposRelatorio = state.camposRelatorio
        .split(',')
        .map((c) => c.trim())
        .filter((c) => c.length > 0);

      telaBase.carregando = true;
      state.parametros = parametrosConsulta;
      console.log('Parâmetros para consulta:', parametrosConsulta);
      const listaPaginada = await servicoRelatorioPCP.obterRelatorioPCP(parametrosConsulta);
      state.dados = listaPaginada;
      console.log('Dados retornados da consulta:', listaPaginada);
      telaBase.carregando = false;
    }

    async function imprimir(tipoArquivoRelatorio: ETipoArquivo) {
      telaBase.carregando = true;

      if (!UtilitarioGeral.validaLista(state.dados.itens)) {
        await buscarRelatorio();
      }

      const retornoRelatorio = await servicoRelatorioPCP.obterArquivRelatorioPCP(
        tipoArquivoRelatorio,
        state.parametros,
      );

      telaBase.carregando = false;

      if (retornoRelatorio.status === EStatusRetornoRequisicao.Sucesso) {
        if (tipoArquivoRelatorio === ETipoArquivo.PDF) {
          state.arquivoPdf = [{
            nome: '',
            link: retornoRelatorio.link,
          }];
        } else {
          UtilitarioGeral.downloadArquivo(retornoRelatorio.link);
        }
      } else if (retornoRelatorio.status === EStatusRetornoRequisicao.Alerta) {
        apresentarMensagemAlerta(retornoRelatorio.mensagem);
      } else {
        apresentarMensagemErro(retornoRelatorio.mensagem);
      }
    }

    async function atualizarSelecaoEmpresas() {
      telaBase.empresasSelecionadas = [dadosEmpresa.value.codigoEmpresa];
      telaBase.permissaoDados = await filtrarPermissaoDadosUsuarioMultiEmpresas(
        telaBase.empresasSelecionadas,
      );

      permissaoServico.value = await new ServicoSistema()
        .validarPermissaoModulo(dadosEmpresa.value.codigoEmpresa, 8);
    }

    const filtros = ref({ data: null, tipo: null, status: null });

    async function periodoAlterado() {
      if (state.periodo !== EFiltroPeriodoMovimentoComercial.Personalizado) {
        await buscarRelatorio();
      }
    }

    async function ValidarCampos(campos: IDadosRelatorioCampo[]) {
      if (campos.length === 0) {
        apresentarMensagemAlerta('É necessário adicionar os campos');
        return false;
      }
      return true;
    }

    async function converterCamposRelatorio(valor: string, codigoRelatorio: number): Promise<IDadosRelatorioCampo[]> {
      if (!valor) return [];

      return valor.split(',').map((c) => c.trim()).filter(Boolean).map((campo, index) => ({
        codigo: 0,
        codigoRelatorio,
        campo,
        ordem: index + 1,
      }));
    }

    async function obterDadosRelatorio() {
      state.camposRelatorio = '';
      state.tiposProducao = [];
      state.engenhariaProdutos = [];
      state.materiasPrimas = [];
      state.tiposFiltro = [];

      state.dadosRelatorio = await servicoDadosRelatorio.obter(state.codigoRelatorio, state.empresaSelecionada);

      if (UtilitarioGeral.objetoValido(state.dadosRelatorio)) {
        state.camposRelatorio = state.dadosRelatorio.campos.map((c) => c.campo).join(', ');
        state.tipoRelatorio = state.dadosRelatorio.tipoRelatorio;
        state.tipoAgrupador = state.dadosRelatorio.agrupador;
        state.nomeRelatorio = state.dadosRelatorio.descricao;

        state.tiposFiltro = state.dadosRelatorio.tiposFiltro || [];

        if (state.dadosRelatorio.filtros && Array.isArray(state.dadosRelatorio.filtros)) {
          state.dadosRelatorio.filtros.forEach((filtro) => {
            const valores = filtro.filtrosSelecionados.split(',').map((v: string) => parseInt(v, 10));
            const tipoFiltroStr = String(filtro.tipoFiltro);

            if (tipoFiltroStr === 'TipoProducao') {
              state.tiposProducao = valores;
            } else if (tipoFiltroStr === 'EngenhariaProduto') {
              state.engenhariaProdutos = valores;
            } else if (tipoFiltroStr === 'MateriaPrima') {
              state.materiasPrimas = valores;
            }
          });
        }
      }
      state.dados = {} as IDTORelatorioPCP;
    }

    async function handleSalvarLayout(dados: {
      dadosCadastro: IDadosRelatorio;
      dadosRelatorioCampos: string;
      tipoProducaoModal: number[];
      engenhariaProdutosModal: number[];
      materiasPrimasModal: number[];
    }) {
      let retorno: IRetornoRequisicao = { codigoRegistro: 0, status: 0, mensagem: '' };

      const campos = await converterCamposRelatorio(
        dados.dadosRelatorioCampos,
        dados.dadosCadastro.codigo,
      );

      if (!await ValidarCampos(campos)) { return; }

      const dadosParaSalvar = { ...dados.dadosCadastro };
      dadosParaSalvar.campos = campos;

      const filtros: IDadosRelatorioFiltros[] = [];

      if (dados.dadosCadastro.tiposFiltro?.includes(1) && dados.tipoProducaoModal.length > 0) {
        filtros.push({
          codigo: 0,
          codigoRelatorio: dados.dadosCadastro.codigo || 0,
          tipoFiltro: 'TipoProducao',
          filtrosSelecionados: dados.tipoProducaoModal.join(','),
        });
      }

      if (dados.dadosCadastro.tiposFiltro?.includes(2) && dados.engenhariaProdutosModal.length > 0) {
        filtros.push({
          codigo: 0,
          codigoRelatorio: dados.dadosCadastro.codigo || 0,
          tipoFiltro: 'EngenhariaProduto',
          filtrosSelecionados: dados.engenhariaProdutosModal.join(','),
        });
      }

      if (dados.dadosCadastro.tiposFiltro?.includes(3) && dados.materiasPrimasModal.length > 0) {
        filtros.push({
          codigo: 0,
          codigoRelatorio: dados.dadosCadastro.codigo || 0,
          tipoFiltro: 'MateriaPrima',
          filtrosSelecionados: dados.materiasPrimasModal.join(','),
        });
      }

      dadosParaSalvar.filtros = filtros;
      dadosParaSalvar.tiposFiltro = dados.dadosCadastro.tiposFiltro;

      state.dadosCadastro = dados.dadosCadastro;
      state.dadosRelatorioCampos = dados.dadosRelatorioCampos;
      state.tipoProducaoModal = dados.tipoProducaoModal;
      state.engenhariaProdutosModal = dados.engenhariaProdutosModal;
      state.materiasPrimasModal = dados.materiasPrimasModal;

      if (state.modoEdicaoModal) {
        retorno = await servicoDadosRelatorio.alterar(dadosParaSalvar);
      } else {
        dadosParaSalvar.codigo = 0;
        dadosParaSalvar.codigoEmpresa = state.empresaSelecionada;
        dadosParaSalvar.modulo = 6;
        retorno = await servicoDadosRelatorio.incluir(dadosParaSalvar);
      }

      if (retorno.status === EStatusRetornoRequisicao.Sucesso) {
        apresentarMensagemSucesso(retorno.mensagem);
        state.modalConfiguracaoVisivel = false;
        if (selectRelatorioRef.value) {
          selectRelatorioRef.value.recarregarDados();
        }
        if (state.modoEdicaoModal && state.codigoRelatorio === dadosParaSalvar.codigo) {
          await obterDadosRelatorio();
        }
      } else {
        apresentarMensagemErro(retorno.mensagem);
      }
    }

    async function excluir(codigoRelatorio?: number) {
      const codigoParaExcluir = codigoRelatorio || state.dadosRelatorio.codigo;
      if (!codigoParaExcluir) {
        apresentarMensagemAlerta('Nenhum relatório selecionado para exclusão.');
        return;
      }

      Modal.confirm({
        title: 'Você realmente deseja excluir o Relatório Selecionado?',
        okText: 'Sim',
        okType: 'danger',
        cancelText: 'Não',
        autoFocusButton: null,
        onOk: async () => {
          const retorno = await servicoDadosRelatorio.excluir(codigoParaExcluir);
          if (retorno.status === EStatusRetornoRequisicao.Sucesso) {
            apresentarMensagemSucesso(retorno.mensagem);
            if (selectRelatorioRef.value) {
              selectRelatorioRef.value.recarregarDados();
            }
            if (state.codigoRelatorio === codigoParaExcluir) {
              state.codigoRelatorio = 0;
              state.nomeRelatorio = '';
              state.camposRelatorio = '';
              state.dados = {} as IDTORelatorioPCP;
            }
          } else {
            apresentarMensagemErro(retorno.mensagem);
          }
        },
      });
    }

    async function handleEditReport(report: { codigo: number }) {
      state.modoEdicaoModal = true;
      state.dadosCadastro = {} as IDadosRelatorio;
      state.dadosRelatorioCampos = '';
      state.tipoProducaoModal = [];
      state.engenhariaProdutosModal = [];
      state.materiasPrimasModal = [];

      const dadosRelatorio = await servicoDadosRelatorio.obter(report.codigo, state.empresaSelecionada);
      if (dadosRelatorio) {
        state.dadosCadastro = { ...dadosRelatorio };
        state.dadosRelatorioCampos = dadosRelatorio.campos.map((c) => c.campo).join(', ');

        if (dadosRelatorio.filtros && Array.isArray(dadosRelatorio.filtros)) {
          state.dadosCadastro.tiposFiltro = dadosRelatorio.tiposFiltro || [];

          dadosRelatorio.filtros.forEach((filtro) => {
            const valores = filtro.filtrosSelecionados.split(',').map((v: string) => parseInt(v, 10));
            const tipoFiltroStr = String(filtro.tipoFiltro);
            if (tipoFiltroStr === 'TipoProducao') {
              state.tipoProducaoModal = valores;
            } else if (tipoFiltroStr === 'EngenhariaProduto') {
              state.engenhariaProdutosModal = valores;
            } else if (tipoFiltroStr === 'MateriaPrima') {
              state.materiasPrimasModal = valores;
            }
          });
        }

        state.modalConfiguracaoVisivel = true;
      } else {
        apresentarMensagemErro('Não foi possível carregar os dados do relatório para edição.');
        state.modoEdicaoModal = false;
      }
    }

    function handleDeleteReport(report: { codigo: number }) {
      excluir(report.codigo);
    }

    watch(
      () => state.tiposFiltro,
      (novosTipos, tiposAntigos) => {
        if (tiposAntigos && !novosTipos.includes(1) && tiposAntigos.includes(1)) {
          state.tiposProducao = [];
        }
        if (tiposAntigos && !novosTipos.includes(2) && tiposAntigos.includes(2)) {
          state.engenhariaProdutos = [];
        }
        if (tiposAntigos && !novosTipos.includes(3) && tiposAntigos.includes(3)) {
          state.materiasPrimas = [];
        }
      },
      { deep: true },
    );

    watch(
      () => state.camposRelatorio,
      (novoValor) => {
        montarColunas(novoValor);
      },
      { immediate: true },
    );

    onBeforeMount(async () => {
      state.empresaSelecionada = storeSistema.getters.codigoEmpresaOperacao();
      telaBase.identificadorRecurso = state.identificadorRecurso;
      state.codigoRelatorio = await servicoDadosRelatorio.obterCodigo(state.empresaSelecionada, 6);
      if (state.codigoRelatorio > 0) {
        await obterDadosRelatorio();
        state.mostrarConfiguracao = 2;
      } else {
        state.mostrarConfiguracao = 1;
      }
      state.dadosCadastro.codigo = 0;
      state.dadosCadastro.codigoEmpresa = state.empresaSelecionada;
      state.dadosCadastro.modulo = 6;

      await preencherEmpresasDisponiveis();
      state.dataAtual = await new ServicoSistema().obterDataAtual();

      const dadosEmpresaCache = storeSistema.state.empresasDisponiveis
        .find((c) => c.codigoEmpresa === state.empresaSelecionada);
      if (dadosEmpresaCache) dadosEmpresa.value = dadosEmpresaCache;
    });
    return {
      props,
      filtros,
      state,
      dadosEmpresa,
      telaBase,
      gradeBase,
      buscarRelatorio,
      atualizarSelecaoEmpresas,
      periodoAlterado,
      atualizarPosicoes,
      permitirMovimentacao,
      UtilitarioMascara,
      UtilitarioData,
      ECustomRenderRow,
      EFiltroPeriodoMovimentoComercial,
      imprimir,
      ETipoArquivo,
      window,
      defineAlturaScrollDinamica,
      handleSalvarLayout,
      obterDadosRelatorio,
      selectRelatorioRef,
      iniciarResizeColuna,
      excluir,
      abrirModalConfiguracao,
      handleEditReport,
      handleDeleteReport,
      mostrarTotalizadorQtdProduzir,
    };
  },
});
